import { HTTPAPIConfig } from './http-api.config';
/**
 * will have all the api config mapping for the project
 */
export const APIConfigMapping: {
  [key: string]: HTTPAPIConfig
} = {
  GET_PROJECTS:{
    method:'get',
    apiKeyName: 'GET_PROJECTS'
  },
  CREATE_PROJECT:{
    method:'post',
    apiKeyName: 'CREATE_PROJECT'
  },
  EDIT_PROJECT:{
    method:'post',
    apiKeyName: 'EDIT_PROJECT'
  },
  COPY_PROJECT:{
    method:'post',
    apiKeyName: 'COPY_PROJECT'
  },
  DELETE_PROJECT:{
    method:'delete',
    apiKeyName: 'DELETE_PROJECT'
  },
  ADD_PROJECT_LOGO:{
    method:'multipart',
    apiKeyName: 'ADD_PROJECT_LOGO',
  },
  EDIT_PROJECT_LOGO:{
    method:'multipart',
    apiKeyName: 'EDIT_PROJECT_LOGO'
  },
  ADD_APPLICATION_LOGO:{
    method:'multipart',
    apiKeyName: 'ADD_APPLICATION_LOGO',
  },
  GET_APPLICATIONS:{
    method:'get',
    apiKeyName: 'GET_APPLICATIONS'
  },
  GET_APPLICATION:{
    method:'get',
    apiKeyName: 'GET_APPLICATION'
  },
  CREATE_APPLICATION:{
    method:'post',
    apiKeyName: 'CREATE_APPLICATION'
  },
  EDIT_APPLICATION:{
    method:'post',
    apiKeyName:'EDIT_APPLICATION'
  },
  UPDATE_APPLICATION_MEDIA:{
    method:'post',
    apiKeyName:'UPDATE_APPLICATION_MEDIA'
  },
  EDIT_APPLICATION_LOGO:{
    method:'multipart',
    apiKeyName:'EDIT_APPLICATION_LOGO'
  },
  EDIT_THEME:{
    method:'post',
    apiKeyName:'EDIT_THEME'
  },
  GET_THEME_BYID:{
    method:'get',
    apiKeyName:'GET_THEME_BYID',
    },
  GET_PAGES: {
    method: 'get',
    apiKeyName: 'GET_PAGES'
  },
  COPY_PAGE: {
    method: 'post',
    apiKeyName: 'COPY_PAGE'
  },
  GET_MASTER_PAGES: {
    method: 'get',
    apiKeyName: 'GET_MASTER_PAGES'
  },
  CREATE_MASTER_PAGES:{
    method: 'post',
    apiKeyName: 'CREATE_MASTER_PAGES'
  },
  CREATE_OR_UPDATE_PAGE: {
    method: 'post',
    apiKeyName: 'CREATE_OR_UPDATE_PAGE'
  },
  GET_PAGE: {
    method : 'get',
    apiKeyName : 'GET_PAGE'
  },
  DELETE_PAGE: {
    method: 'delete',
    apiKeyName: 'DELETE_PAGE'
  },
  CREATE_OR_UPDATE_FORM: {
    method: 'post',
    apiKeyName: 'CREATE_OR_UPDATE_FORM'
  },
  DELETE_FORM: {
    method: 'delete',
    apiKeyName: 'DELETE_FORM'
  },
  CREATE_OR_EDIT_WIDGET: {
    method: 'post',
    apiKeyName: 'CREATE_OR_EDIT_WIDGET'
  },
  DELETE_WIDGET: {
    method: 'delete',
    apiKeyName: 'DELETE_WIDGET'
  },
  GET_DEFAULT_PAGES: {
    method: 'post',
    apiKeyName: 'GET_DEFAULT_PAGES'
  },
  PUBLISH_APP: {
    method: 'post',
    apiKeyName: 'PUBLISH_APP'
  },
  ENABLE_PUBLISH: {
    method: 'post',
    apiKeyName: 'ENABLE_PUBLISH'
  },
  GET_THEMES:{
    method:'get',
    apiKeyName: 'GET_THEMES'
  },
  GET_ENTITIES_OR_ATTRIBUTES: {
    method: 'post',
    apiKeyName: 'GET_ENTITIES_OR_ATTRIBUTES'
  },
  CREATE_OR_UPDATE_DATALIST_VIEWPAGE: {
    method: 'post',
    apiKeyName: 'CREATE_OR_UPDATE_DATALIST_VIEWPAGE'
  },
  UPDATE_ENTITY: {
    method: 'post',
    apiKeyName: 'UPDATE_ENTITY'
  },
  DELETE_ENTITY: {
    method: 'post',
    apiKeyName: 'DELETE_ENTITY'
  },
  FETCH_PREVIEW: {
    method: 'post',
    apiKeyName: 'FETCH_PREVIEW'
  },
  DELETE_PREVIEW: {
    method: 'delete',
    apiKeyName: 'DELETE_PREVIEW'
  },
  GET_APK_DETAILS: {
    method: 'post',
    apiKeyName: 'GET_APK_DETAILS'
  },
  GET_METRICS:{
    method:'post',
    apiKeyName: 'GET_METRICS'
  },
  GET_ENTITY_SUBMISSION_DATA: {
    method: 'post',
    apiKeyName: 'GET_ENTITY_SUBMISSION_DATA',
    routerParamsToAdd: {
      queryParams: {
        id: 'application_id'
      }
    },
    options: {
      responseType: 'blob' as 'json'
    }
  },
  WIDGET_REARRANGE:{
    method:'post',
    apiKeyName:'WIDGET_REARRANGE'
  },
  GET_MOB_AND_WEB_ENTITIES: {
    method: 'post',
    apiKeyName: 'GET_MOB_AND_WEB_ENTITIES'
  },
  GET_ENTITY_SUBMISSIONS_DATA: {
    method: 'post',
    apiKeyName: 'GET_ENTITY_SUBMISSIONS_DATA'
  },
  GET_APPLICATION_TYPES:{
    method:'get',
    apiKeyName:'GET_APPLICATION_TYPES'
  },
  CREATE_THEME:{
    method:'post',
    apiKeyName: 'CREATE_THEME'
  },
  MOBILE_LOGIN: {
    method: 'post',
    apiKeyName: 'MOBILE_LOGIN',
    urlString:'USERMGMT_API'
  },
  DISABLE_USER:{
    method:'get',
    apiKeyName:'DISABLE_USER',
    urlString:'USERMGMT_API'
  },
  CHECK_APPLICATION_NAME:{
    method:'get',
    apiKeyName: 'CHECK_APPLICATION_NAME'
  },
  CREATE_CUSTOM_API:{
    method:'post',
    apiKeyName:'CREATE_CUSTOM_API'
  },
  UPDATE_CUSTOM_API:{
    method:'post',
    apiKeyName:'UPDATE_CUSTOM_API'
  },
  GET_ALL_APIS:{
    method:'post',
    apiKeyName:'GET_ALL_APIS'
  },
  GET_API:{
    method:'get',
    apiKeyName:'GET_API'
  },
  DELETE_API:{
    method:'post',
    apiKeyName:'DELETE_API'
  },
  GET_CUSTOM_API_RESPONSE:{
    method:'post',
    apiKeyName:'GET_CUSTOM_API_RESPONSE'
  },
  ADD_OR_UPDATE_WIDGET_IMAGE:{
    method:'multipart',
    apiKeyName:'ADD_OR_UPDATE_WIDGET_IMAGE'
  },
  SOCIAL_LOGIN: {
    method: 'post',
    apiKeyName: 'SOCIAL_LOGIN',
    urlString:'USERMGMT_API'
  },
  PLAYSTORE_CERTIFICATE:{
    method:'multipart',
    apiKeyName:'PLAYSTORE_CERTIFICATE'
  },
  PLAYSTORE_CERTIFICATE_LIST:{
    method:'post',
    apiKeyName:'PLAYSTORE_CERTIFICATE_LIST'
  },
  WEB_APP_URL:{
    method:'get',
    apiKeyName:'WEB_APP_URL'
  },
  FETCH_ROLES: {
    method: 'get',
    apiKeyName: 'FETCH_ROLES',
    urlString: 'USERMGMT_API'
  },
  WORKFLOW_CREATE_UPDATE: {
    method: 'post',
    apiKeyName: 'WORKFLOW_CREATE_UPDATE'
  },
  STAGE_CREATE_UPDATE: {
    method: 'post',
    apiKeyName: 'STAGE_CREATE_UPDATE'
  },
  WORKFLOW_FETCH: {
    method: 'get',
    apiKeyName: 'WORKFLOW_FETCH'
  },
  WORKFLOW_DELETE: {
    method: 'delete',
    apiKeyName: 'WORKFLOW_DELETE'
  },
  STAGE_DELETE: {
    method: 'delete',
    apiKeyName: 'STAGE_DELETE'
  },
  STAGE_FETCH: {
    method: 'get',
    apiKeyName: 'STAGE_FETCH'
  },
  PRIVACY_POLICY_ADD_OR_EDIT: {
    method: 'post',
    apiKeyName: 'PRIVACY_POLICY_ADD_OR_EDIT'
  },
  PRIVACY_POLICY_GET: {
    method: 'get',
    apiKeyName: 'PRIVACY_POLICY_GET'
  },
  FETCH_POLICY_BY_APPLICATIONID: {
    method: 'get',
    apiKeyName: 'FETCH_POLICY_BY_APPLICATIONID'
  },
  RESET_PRIVACY_POLICY: {
    method: 'post',
    apiKeyName: 'RESET_PRIVACY_POLICY'
  },
  UPLOAD_ENTITY_DATA: {
    method: 'post',
    apiKeyName: 'UPLOAD_ENTITY_DATA'
  },
  UPLOAD_FILE: {
    method: 'multipart',
    apiKeyName: 'UPLOAD_FILE'
  },
  FETCH_ENTITY_ENTRIES: {
    method: 'post',
    apiKeyName: 'FETCH_ENTITY_ENTRIES'
  },
  EDIT_ENTITY_ENTRY: {
    method: 'post',
    apiKeyName: 'EDIT_ENTITY_ENTRY'
  },
  DELETE_ENTITY_ENTRY: {
    method: 'post',
    apiKeyName: 'DELETE_ENTITY_ENTRY'
  },

  FETCH_ADDITIONAL_USERFORM_FIELDS: {
    method:'get',
    apiKeyName:'FETCH_ADDITIONAL_USERFORM_FIELDS',
    urlString:'USERMGMT_API'
  },

  // media resource(mobilebuilder)
  GET_MEDIA_IMAGES: {
    method:'get',
    apiKeyName:'GET_MEDIA_IMAGES',
  },
  CHECK_REPLACE_MEDIA_LINKS: {
    method:'post',
    apiKeyName:'CHECK_REPLACE_MEDIA_LINKS',
  },
  UPLOAD_MEDIA_IMAGE: {
    method:'multipart',
    apiKeyName:'UPLOAD_MEDIA_IMAGE',
  },
  REPLACE_MEDIA_IMAGE: {
    method:'multipart',
    apiKeyName:'REPLACE_MEDIA_IMAGE',
  },
  DELETE_MEDIA_IMAGE: {
    method:'post',
    apiKeyName:'DELETE_MEDIA_IMAGE',
  },

  STREAM_API: {
    method:'post',
    apiKeyName:'STREAM_API',
  },
    //migrate project
  MIGRATE_PROJECT: {
    method:'post',
    apiKeyName:'MIGRATE_PROJECT',
  },
  FETCH_DIFFERENT_ENV_PROJECTS: {
    method:'get',
    apiKeyName:'FETCH_DIFFERENT_ENV_PROJECTS',
  },
};
